import type { TooltipProps } from 'antd';
import type { LabelTooltipType } from 'antd/es/form/FormItemLabel';

import { ReactComponent as TooltipIcon } from '../../../assets/icons/tooltip-icon.svg';
import { getStyleVariableValue } from '../../../utilz';
import SvgConverter from './SvgConverter';

const formLabelToolTip = (title: TooltipProps['title']): LabelTooltipType => {
  return {
    color: getStyleVariableValue('--label'),
    icon: <SvgConverter Icon={TooltipIcon} color="black" width={16} height={16} />,
    overlayClassName: 'f-14',
    overlayInnerStyle: {
      borderRadius: 5,
      padding: '8px 15px',
      width: 300,
    },
    placement: 'bottomLeft',
    title,
  };
};

export default formLabelToolTip;
